import { useQuery } from "react-query";
import axios from "infra/http";
import { SolicitacaoCadastroDetails } from "../typings";

function useGetSolicitacaoCadastroById(id: string) {
  return useQuery(["/solicitacao-cadastro", id], async () => {
    const { data } = await axios.get<SolicitacaoCadastroDetails>(
      `/v1/solicitacao-cadastro/${id}`
    );

    return data;
  });
}

export default useGetSolicitacaoCadastroById;
